function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Alert, Tag, Tabs, Divider, Descriptions } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Page, Document, pdfjs } from 'react-pdf';
import Moment from "react-moment";
import Common from "./includes/Common";
import { Folder2Open, Alexa, ShareFill } from "react-bootstrap-icons";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var DisplayFile = function DisplayFile(_ref) {
  var file_url = _ref.file_url;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    numberOfPages = _useState2[0],
    setNumberOfPages = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    pageN = _useState4[0],
    setPageN = _useState4[1];
  var onDocumentLoadSuccess = function onDocumentLoadSuccess(_ref2) {
    var numberOfPages = _ref2.numberOfPages;
    setNumberOfPages(numberOfPages);
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: file_url != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("div", {
        className: "eduBkg",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsxs("div", {
                className: "tr-white",
                children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), file_url != null && /*#__PURE__*/_jsx(DocViewer, {
                  documents: [{
                    uri: (Common.baseUrl + file_url).replace(/\s/g, '')
                  }],
                  pluginRenderers: DocViewerRenderers,
                  language: "fr",
                  config: {
                    header: {
                      disableHeader: false,
                      disableFileName: true
                    }
                  }
                }), /*#__PURE__*/_jsx(Divider, {})]
              })
            })
          })
        })
      })
    })
  });
};
export default DisplayFile;